import React from "react";
import { Link } from "react-router-dom";
import image_icon from "../../Images/image_icon.png";
import {
  PHONE_BOOKING_DISPLAY,
  PHONE_BOOKING_TEL,
  PHONE_MAIN_DISPLAY,
  PHONE_MAIN_TEL,
  ADDRESS_LINE,
  MAP_LINK,
} from "../../constants/contact";
import "./siteHeader.scss";

type Props = {
  /** Short line under logo, e.g. «Доставка» / «Меню» */
  tagline?: string;
};

export default function SiteHeader({ tagline }: Props) {
  return (
    <div className="site-header">
      <a
        className="site-header__address"
        href={MAP_LINK}
        target="_blank"
        rel="noreferrer"
      >
        {ADDRESS_LINE}
      </a>

      <Link className="site-header__brand" to="/" aria-label="На главную">
        <img src={image_icon} alt="" />
      </Link>

      <div className="site-header__actions">
        {tagline ? (
          <span className="site-header__tagline">{tagline}</span>
        ) : null}
        <a className="cta-phone site-header__cta" href={PHONE_BOOKING_TEL}>
          Позвонить · {PHONE_BOOKING_DISPLAY}
        </a>
        <a className="site-header__tel-secondary" href={PHONE_MAIN_TEL}>
          {PHONE_MAIN_DISPLAY}
        </a>
      </div>
    </div>
  );
}
